import { format, parse } from 'date-fns';
import { IFixture } from '../definitions';
import { callFirebaseFunction } from './firebaseCallable';
import { buildShareUrl } from './shareUrl';
import { fixtureKey } from './utils';

interface CreateFixtureAttendanceLinkResponse {
  token: string;
  attendingCode: string;
  notAttendingCode: string;
}

interface ClaimAttendanceSupportersResponse {
  claimedTeams: string[];
  claimedRecords: number;
}

export async function claimAttendanceSupporters(): Promise<ClaimAttendanceSupportersResponse> {
  return callFirebaseFunction<Record<string, never>, ClaimAttendanceSupportersResponse>(
    'claimAttendanceSupporters',
    {},
  );
}

export async function createFixtureAttendanceMessage(
  teamUuid: string,
  teamName: string,
  fixture: IFixture,
): Promise<string> {
  const { attendingCode, notAttendingCode } = await callFirebaseFunction<
    { teamUuid: string; fixtureKey: string },
    CreateFixtureAttendanceLinkResponse
  >('createFixtureAttendanceLink', {
    teamUuid,
    fixtureKey: fixtureKey(fixture),
  });
  const attendingUrl = buildShareUrl(`/a/${encodeURIComponent(attendingCode)}`);
  const notAttendingUrl = buildShareUrl(`/a/${encodeURIComponent(notAttendingCode)}`);
  let dateLabel = fixture.date;
  try {
    dateLabel = format(parse(fixture.date, 'yyyyMMdd', new Date()), 'EEE d MMM yyyy');
  } catch {
    // Keep the stored date when legacy data cannot be parsed.
  }
  const opponent = fixture.teams?.join(' vs ') || 'Opponent TBC';
  const attendingEmoji = '\u2705';
  const notAttendingEmoji = '\u274C';

  return [
    `Fixture: ${teamName} vs ${opponent}, ${fixture.venue || 'Venue TBC'}, ${dateLabel}, ${fixture.time || 'Time TBC'}`,
    `${attendingEmoji} I can attend: ${attendingUrl}`,
    `${notAttendingEmoji} I can't attend: ${notAttendingUrl}`,
  ].join('\n');
}